import Price from '~/utils/Price';

export class ThirdPriceDeviation {
	public constructor(
		public readonly firstCountryPrice: Price,
		public readonly comparativePriceInFirstTwoCountries: Price,
		public readonly thirdCountryAlpha2: string,
		public readonly thirdCountryPrice: Price,
		public readonly deviationPercents: number,
		public readonly aboveThreshold: boolean
	) {}
}
